import data from "../careerSlugs.json";

export const getCareerSlug = (id: string | number) => {
  const slug = data as { ids: number[]; id: string }[];

  // @ts-ignore
  return slug.find(({ ids }) => ids.includes(id)).id;
};
